import React, { useEffect } from "react";
import "./FooterSubscribe.css";
import "./MailerLiteEmbed.css";

function ensureMailerLiteLoaded() {
  // MailerLite bootstrap: create a queued ml() function if it doesn't exist yet.
  // Then load the universal script once and register the account.
  if (!window.ml) {
    window.ml = function () {
      // eslint-disable-next-line prefer-rest-params
      (window.ml.q = window.ml.q || []).push(arguments);
    };
  }

  // Register account (safe to call multiple times; ML queues if needed)
  try {
    window.ml("account", "2061388");
  } catch (e) {
    // no-op
  }

  // Load universal.js once
  if (document.querySelector('script[data-ml-universal="true"]')) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://assets.mailerlite.com/js/universal.js";
  script.setAttribute("data-ml-universal", "true");
  script.onload = () => {
    try {
      window.ml && window.ml("account", "2061388");
    } catch (e) {
      // no-op
    }
  };
  document.head.appendChild(script);
}

function FooterSubscribe() {
  useEffect(() => {
    ensureMailerLiteLoaded();
  }, []);

  return (
    <section className="footer-subscribe" aria-label="Subscribe">
      <div className="footer-subscribe-formBlock">
        <div className="ml-embedded" data-form="mIYj0Q" />
      </div>
    </section>
  );
}

export default FooterSubscribe;

